import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navStatus: 1,
    roles: "",
    username: "",
    sex: "",
    avatar: "",
  },
  getters: {},
  mutations: {
    setNavStatus(state, navStatus) {
      state.navStatus = navStatus;
    },
    setRoles(state, roles) {
      state.roles = roles;
    },
    setUsername(state, username) {
      state.username = username;
    },
    setSex(state, sex) {
      state.sex = sex;
    },
    setAvatar(state, avatar) {
      state.avatar = avatar;
    },
  },
  actions: {
    updateNavStatus({ commit }, navStatus) {
      commit("setNavStatus", navStatus);
    },
    updateRoles({ commit }, roles) {
      commit("setRoles", roles);
    },
    updateUsername({ commit }, username) {
      commit("setUsername", username);
    },
    updateSex({ commit }, sex) {
      commit("setSex", sex);
    },
    updateAvatar({ commit }, avatar) {
      commit("setAvatar", avatar);
    },
  },
  modules: {},
  plugins: [createPersistedState()]  // 启用持久化插件
});
